import React, { useMemo } from 'react'
import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import { getActivePackagesByRoom, PackageOptionViewByRoom } from 'selectors/offerPage/multipleRoomBookingSelectors'
import { getDurationPackageOptions, OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { max } from 'lib/array/arrayUtils'
import MobileMultipleRoomsBookingRoomOption from './MobileMultipleRoomsBookingRoomOption'

interface Props {
  rooms: Array<App.RoomOccupants>;
  checkIn: string;
  packageOptions: Array<OfferPackageOptionView>;
  multipleRoomPackages: PackageOptionViewByRoom;
}

function MobileMultipleRoomsBookingIndividualRooms(props: Props) {
  const { checkIn, rooms, multipleRoomPackages, packageOptions } = props

  const availableRoomCountByRoomId = useMemo(() => {
    const availablePackageOptions = packageOptions.filter(packageOption => (packageOption.availableRooms || 0) > 0)
    const packageView = max(availablePackageOptions, packageView => packageView.package.roomType?.stats.booked || 0)
    if (packageView?.availableRooms && packageView.package.roomType?.id && packageView.availableRooms > 0 && packageView.availableRooms <= 10) {
      return new Map([[packageView.package.roomType?.id, packageView?.availableRooms]])
    }
    return new Map()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packageOptions, checkIn])

  return (
    <Pane background="neutral-six">
      <Group direction="vertical" gap={8}>
        {rooms.map((room, index) => {
          const packageView = multipleRoomPackages[room.roomId]
          if (!packageView) return null // TODO: Add invalid selection state here
          return <MobileMultipleRoomsBookingRoomOption
            key={room.roomId}
            room={room}
            roomPosition={index + 1}
            packageView={packageView}
            availableRoomCount={availableRoomCountByRoomId.get(room.roomId)}
          />
        })}
      </Group>
    </Pane>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  rooms: state.rooms,
  checkIn: state.checkInDate,
  packageOptions: getDurationPackageOptions(state, appState),
  multipleRoomPackages: getActivePackagesByRoom(state, appState),
}), MobileMultipleRoomsBookingIndividualRooms)
